import { Box, Typography } from "@material-ui/core"
import { useGroupCardContext } from "components/Balance/GroupCardContext"
import SingleButtonSelection from "components/Reusable/Bit/SingleButtonSelection"
import { useRouter } from "next/router"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import colors from "theme/colors"
import HeadingText from "../Texts/HeadingText"

const StyledBox = styled(Box)`
  margin-top: 30px;
  ${(p) => p.theme.breakpoints.up("md")} {
    width: 690px;
    margin-top: 40px;
  }
`

const StyledText = styled(Typography).attrs({ variant: "body1" })`
  text-align: right;
  line-height: 26px;
`

const StyledButtonWrapper = styled(Box)<{ $groupPurchase?: boolean }>`
  margin-top: 20px;
  margin-bottom: 20px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    button {
      width: 33.333%;
      ${(p) => p?.$groupPurchase && `width: 50%;`}
    }
  }
`

const StyledLabel = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const StyledButton = styled(Box)<{ $isSelected?: boolean }>`
  width: 158px;
  height: 55px;
  background-color: ${(p) => (p.$isSelected ? "#264f36" : "#f7f7f7")};
  color: ${(p) => (p.$isSelected ? "#fff" : "#757575")};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "NarkisBlock";
  font-size: 24px;
  font-weight: bold;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: 46px;
    margin-left: 10px;
    line-height: 23px;
    padding: 10px;
  }

  :hover {
    border: 1px solid ${colors.darkGreen};
  }
`

const StyledTextItem = styled.div`
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 90px;
  }
`

type GiftCardSchedulerProps = {
  setScheduleType: Dispatch<SetStateAction<string>>
  scheduleType: string
  setSchedulerType: Dispatch<SetStateAction<string>>
  groupPurchase?: boolean
}

const GiftCardScheduler = ({
  setScheduleType,
  scheduleType,
  setSchedulerType,
  groupPurchase,
}: GiftCardSchedulerProps) => {
  const { setScheduleTime } = useGroupCardContext()
  const router = useRouter()
  const isGroupPurchase = router.pathname.includes("groupPurchase")
  const buttons = isGroupPurchase
    ? [
        { value: "AfterPayment", text: "שלחו עכשיו" },
        { value: "Scheduled", text: "במועד אחר שאבחר" },
      ]
    : [
        { value: "Allowance", text: "דמי כיס" },
        { value: "AfterPayment", text: "חד פעמי שלחו עכשיו" },
        { value: "Scheduled", text: "חד פעמי במועד שאבחר" },
      ]

  const handleButtonClick = (code) => {
    if (code === "AfterPayment") setScheduleTime("")
    setScheduleType(code)
    setSchedulerType(code)
  }

  return (
    <StyledBox>
      {!isGroupPurchase && (
        <>
          <HeadingText text={"איזה גיפטקארד לשלוח?"} />
          <StyledText>
            בחרו חד פעמי או דמי כיס שיישלחו קבוע כל תקופת זמן
          </StyledText>
        </>
      )}
      <StyledButtonWrapper $groupPurchase={groupPurchase}>
        <SingleButtonSelection
          id="scheduleSelect"
          items={buttons.map((amount) => ({
            value: amount.value,
            name: amount.text,
          }))}
          noFocus
          onSelect={(code) => handleButtonClick(code)}
          gap={15}
          itemsPerRow={"auto"}
          selectedValue={scheduleType}
          customButton={(radioId, isSelected, item) => {
            return (
              <>
                <StyledLabel htmlFor={radioId} $activeButton={isSelected}>
                  <StyledButton $isSelected={isSelected}>
                    <StyledTextItem>{item.name}</StyledTextItem>
                  </StyledButton>
                </StyledLabel>
              </>
            )
          }}
        />
      </StyledButtonWrapper>
    </StyledBox>
  )
}

export default GiftCardScheduler
